import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import enrollmeGateway from '@hixme/enrollme-api-gateway'
import { setGateway } from '@hixme/redux-gateway'
import { AuthenticatedComponent, selectors as authSelectors } from '@hixme/auth-ui'

// project
import * as personSelectors from 'store/modules/persons/selectors'
import userSession, {
  actions as userSessionActions,
  containers as userSessionContainers,
  selectors as userSessionSelectors,
} from 'store/modules/user-session'
import appConfig from 'modules/app-config'
import { loadZendesk } from 'modules/analytics'
import { loadDatadogRUM } from 'helpers/datadog'

// module
import EnrollmeLayout from './EnrollmeLayout'

const { UserSessionContainer } = userSessionContainers

export class EnrollmeLayoutContainer extends Component {
  componentWillMount() {
    this.initializeAPIGateway(this.props)
    loadDatadogRUM()
    loadZendesk()
  }

  componentWillReceiveProps(props) {
    if (props.credentials && props.credentials.idToken !== this.props.credentials.idToken) {
      this.initializeAPIGateway(props)
    }
  }

  initializeAPIGateway() {
    // Setup AWS API Gateway and redux-gateway
    const { credentials } = this.props
    if (credentials) {
      // enrollmeGateway.newClient throws synchronously if it has no route config
      // for the current stage (e.g. a stage whose routes-<stage>.json isn't shipped).
      // Guard it so a missing/bad stage config degrades to "no gateway" instead of
      // crashing the whole authenticated layout. See EMS-9106.
      try {
        const gateway = enrollmeGateway.newClient(credentials, appConfig.getStage())
        setGateway(gateway)
      } catch (err) {
        console.error(`Failed to initialize API gateway for stage "${appConfig.getStage()}"`, err)
      }
    }
  }

  render() {
    const { children, person, ...restProps } = this.props

    return (
      <UserSessionContainer>
        <EnrollmeLayout {...restProps} person={person}>
          {children}
        </EnrollmeLayout>
      </UserSessionContainer>
    )
  }
}

EnrollmeLayoutContainer.displayName = 'EnrollmeLayoutContainer'
EnrollmeLayoutContainer.propTypes = {
  children: PropTypes.element.isRequired,
  credentials: PropTypes.object,
  userCredentials: PropTypes.object,
  token: PropTypes.string,
  person: PropTypes.object,
}
EnrollmeLayoutContainer.defaultProps = {
  credentials: undefined,
  userCredentials: undefined,
  token: undefined,
  person: undefined,
}

const mapStateToProps = (state) => ({
  username: userSession.selectors.getUserName(state),
  userCredentials: authSelectors.getCredentials(state),
  token: authSelectors.getToken(state),
  person: personSelectors.getPerson(state),
  clientPublicKey: userSessionSelectors.getClientPublicKey(state),
  companyName: userSessionSelectors.getCompanyName(state),
})

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  initializeUserSession: (userCredentials) => {
    dispatch(userSessionActions.initializeUser(userCredentials))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticatedComponent(EnrollmeLayoutContainer))
